module.exports = __webpack_public_path__ + "9000fe8c3448da1ca489783cfde1d155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/podzimni-detsky-tabor-1.jpg
// module id = 1196
// module chunks = 0